var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submenu-group"},[_c('div',{staticClass:"submenu-group__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"submenu-group__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }